import './downloads.scss';

export default () => {
	const headers = document.querySelectorAll('.js-accordion-title');

	headers.forEach(header => {
		header.addEventListener('click', () => {
			const activeItem = header.parentElement;
			const content = activeItem.querySelector('.js-accordion-content');

			if (content.style.maxHeight) {
				content.style.maxHeight = null;
				activeItem.classList.remove('active');
			} else {
				// Close all open accordions and remove active class
				document.querySelectorAll('.js-accordion-content').forEach(item => {
					item.style.maxHeight = null;
					item.parentElement.classList.remove('active');
				});

				content.style.maxHeight = content.scrollHeight + "px";
				activeItem.classList.add('active');
			}
		});
	});

};
